import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../lib/i18n';

const PORTRAIT =
  'https://customer-assets.emergentagent.com/job_sacred-moments-34/artifacts/mm3y3hap_2ce7cac7-765a-4ca4-8f02-c9bada500bea.jpg';

export const About = () => {
  const { t } = useI18n();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative text-cream overflow-hidden bg-coldpink"
    >
      <div className="grid md:grid-cols-12 min-h-[720px]">
        {/* Left: full-height portrait */}
        <div className="md:col-span-6 lg:col-span-5 relative h-[70vh] md:h-auto min-h-[480px]">
          <img
            src={PORTRAIT}
            alt="Portrait of the facilitator"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
            data-testid="about-portrait"
          />
          <div className="absolute inset-0 bg-burgundy/15 mix-blend-multiply" />
        </div>

        {/* Right: text */}
        <div className="md:col-span-6 lg:col-span-6 lg:col-start-7 flex items-center px-6 md:px-12 lg:px-16 py-20 md:py-28">
          <div className="max-w-xl">
            <span className="text-[10px] tracking-[0.4em] uppercase text-cream/70 font-body block mb-5">
              — {t.about.eyebrow}
            </span>
            <h2 className="font-display font-medium text-cherry-glow text-4xl md:text-5xl lg:text-6xl leading-[1.02] mb-8">
              {t.about.title}<span className="text-cherry-glow">.</span>
            </h2>
            <p className="font-display font-medium text-xl md:text-2xl leading-snug text-burgundy mb-6">
              {t.about.bodyA}
            </p>
            <p className="font-body text-cream/85 text-base leading-relaxed mb-10 max-w-lg">
              {t.about.bodyB}
            </p>

            <Link
              to="/about"
              data-testid="about-learn-more"
              className="group inline-flex items-center gap-3 border border-cream text-cream px-6 py-3 hover:bg-cream hover:text-coldpink transition-colors duration-500"
            >
              <span className="text-[10px] tracking-[0.4em] uppercase font-body font-medium">
                {t.about.learnMore}
              </span>
              <span aria-hidden="true" className="font-display text-xl group-hover:translate-x-1 transition-transform">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
